import { ExpandMore, ExpandLess } from "@mui/icons-material";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import useGetCachesHandler from "@/hooks/useGetCachesHandler";

function FormulaDropDown({ currentFormula, recommended, handleFormulaChange }) {
  const [recommendedFormulae, setRecommendedFormulae] = useState([]);
  const [advancedFormulae, setAdvancedFormulae] = useState([]);
  const [showRecommendedFormulae, setShowRecommendedFormulae] = useState(true);
  const [showAdvancedFormulae, setShowAdvancedFormulae] = useState(false);
  const { getFormulaeCache } = useGetCachesHandler();

  // set up formula options
  useEffect(() => {
    getFormulaeCache().then((data) => {
      const advancedFormulae = [];
      const recommendedFormulae = [];

      Object.entries(data).map((formula) => {
        if (recommended.includes(formula[0])) {
          recommendedFormulae.push({
            name: formula[0],
            description: formula[1]["description"],
          });
        } else {
          advancedFormulae.push({
            name: formula[0],
            description: formula[1]["description"],
          });
        }
      });
      setRecommendedFormulae(recommendedFormulae);
      setAdvancedFormulae(advancedFormulae);
    });
    // getFormulaeCache is recreated by useGetCachesHandler every render;
    // intentionally fire only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!recommended.includes(currentFormula)) {
      setShowAdvancedFormulae(true);
    }
    // Intentionally fire only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <List
        sx={{ width: "100%", border: "1px solid #ddd", borderRadius: 2, p: 0 }}
      >
        {/* RECOMMENDED FORMULAE */}
        <ListItemButton
          onClick={() => setShowRecommendedFormulae(!showRecommendedFormulae)}
          sx={{ color: "primary.main" }}
        >
          <ListItemText primary={"Recommended Formulae"} />
          {showRecommendedFormulae ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={showRecommendedFormulae} timeout="auto">
          <List component="div" disablePadding sx={{ bgcolor: "grey.50" }}>
            {recommendedFormulae.map((f) => {
              const isSelected = f.name === currentFormula;

              return (
                <ListItemButton
                  key={f.name}
                  selected={isSelected}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleFormulaChange(f)}
                >
                  <ListItemText primary={f.name} />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>

        <Divider />

        {/* ADVANCED OPTIONS */}
        <ListItemButton
          onClick={() => setShowAdvancedFormulae(!showAdvancedFormulae)}
          sx={{ color: "primary.main" }}
        >
          <ListItemText primary={"Advanced Options"} />
          {showAdvancedFormulae ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={showAdvancedFormulae} timeout="auto">
          <List component="div" disablePadding sx={{ bgcolor: "grey.50" }}>
            {advancedFormulae.map((f) => {
              const isSelected = f.name === currentFormula;

              return (
                <ListItemButton
                  key={f.name}
                  selected={isSelected}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleFormulaChange(f)}
                >
                  <ListItemText primary={f.name} />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      </List>
    </Box>
  );
}

FormulaDropDown.propTypes = {
  currentFormula: PropTypes.string,
  handleFormulaChange: PropTypes.func,
  recommended: PropTypes.array,
};

export default FormulaDropDown;
